module.exports = __webpack_public_path__ + "static/media/icn_tick.d8b12279.svg";